export { default } from './IngredientCard';
